import * as React from 'react';
import { HonestWork } from '@cian/honestwork-component';
import * as style from './index.css';

export class HonestWorkHorizontal extends React.Component {
  private handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  public render() {
    return (
      <div onClick={this.handleClick} className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
        <HonestWork className={style['honest-work']} />
      </div>
    );
  }
}
